
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Checkbox: () => import("@/components/Checkbox.vue")
  }
})
export default class UsersIndex extends Vue {
  title: string = "";
  company: any = {};
  currencies: any = [];
  currencyId: number = 0;

  mounted() {
    this.init();
  }

  async init() {
    await this.loadCompany();
    this.loadCurrencies();
  }

  async loadCompany() {
    let response: any = await (this.$root as any)._post(
      `companies/one/${this.$route.params.id}`,
      {
        models: "currencies"
      }
    );
    this.company = response.data[0];
    this.title = `Actualizar Monedas de ${this.company.name}`;
  }

  async addCurrency() {
    await (this.$root as any)._post("companiescurrencies", {
      companyId: this.$route.params.id,
      currencyId: this.currencyId,
      can_do_request: true
    });
    (this.$root as any).notify("Se agrego la moneda con éxito.");
    this.init();
  }

  async loadCurrencies() {
    const response: any = await (this.$root as any)._get("currencies/all");
    this.currencies = response.data.filter(
      (c: any) => !this.company.currencies.some((cc: any) => cc.id === c.id)
    );
    this.currencyId = 0;
  }

  async toggleCanDoRequest(currency: any) {
    try {
      await (this.$root as any)._put(
        `companiescurrencies/${this.$route.params.id}/${currency.id}`,
        {
          can_do_request: currency.companies_currencies.can_do_request
        }
      );
    } catch (e) {
      (this.$root as any).notify("No se pudo actualizar el valor.", "error");
    }
  }
}
